import React from 'react';
import './WeatherEffect.css';

const WeatherEffect = ({ effect, intensity = 'medium' }) => {
  if (!effect || effect === 'none') {
    return null;
  }

  if (effect === 'snow') {
    return <SnowEffect intensity={intensity} />;
  }

  if (effect === 'rain') {
    return <RainEffect intensity={intensity} />;
  }

  if (effect === 'wind') {
    return <WindEffect intensity={intensity} />;
  }

  if (effect === 'sun') {
    return <SunEffect />;
  }

  if (effect === 'autumn') {
    return <AutumnEffect intensity={intensity} />;
  }

  if (effect === 'valentin') {
    return <ValentinEffect intensity={intensity} />;
  }

  if (effect === 'spring') {
    return <SpringEffect intensity={intensity} />;
  }

  return null;
};

// ==================== EFFET NEIGE ====================
const SnowEffect = ({ intensity }) => {
  const counts = { light: 30, medium: 50, heavy: 80 };
  const count = counts[intensity] || counts. medium;

  const snowflakes = Array.from({ length: count }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    animationDuration:  5 + Math.random() * 10,
    animationDelay: Math.random() * 5,
    fontSize: 10 + Math.random() * 20,
    opacity: 0.5 + Math.random() * 0.5
  }));

  return (
    <div className="weather-effect snow-effect">
      {snowflakes.map((flake) => (
        <div
          key={flake.id}
          className="snowflake"
          style={{
            left: `${flake.left}%`,
            animationDuration: `${flake.animationDuration}s`,
            animationDelay: `${flake.animationDelay}s`,
            fontSize: `${flake.fontSize}px`,
            opacity: flake.opacity
          }}
        >
          ❅
        </div>
      ))}
    </div>
  );
};

// ==================== EFFET PLUIE ====================
const RainEffect = ({ intensity }) => {
  const counts = { light: 50, medium:  100, heavy: 150 };
  const count = counts[intensity] || counts.medium;

  const raindrops = Array. from({ length: count }, (_, i) => ({
    id: i,
    left: Math. random() * 100,
    animationDuration: 0.5 + Math.random() * 0.5,
    animationDelay: Math.random() * 2,
    height: 10 + Math.random() * 20
  }));

  return (
    <div className="weather-effect rain-effect">
      {raindrops.map((drop) => (
        <div
          key={drop.id}
          className="raindrop"
          style={{
            left: `${drop.left}%`,
            animationDuration: `${drop.animationDuration}s`,
            animationDelay: `${drop.animationDelay}s`,
            height: `${drop.height}px`
          }}
        />
      ))}
    </div>
  );
};

// ==================== EFFET VENT ====================
const WindEffect = ({ intensity }) => {
  const counts = { light: 15, medium: 25, heavy: 40 };
  const count = counts[intensity] || counts.medium;

  const windParticles = Array.from({ length: count }, (_, i) => ({
    id: i,
    top: Math.random() * 100,
    animationDuration: 2 + Math.random() * 3,
    animationDelay:  Math.random() * 3,
    opacity: 0.3 + Math.random() * 0.4
  }));

  return (
    <div className="weather-effect wind-effect">
      {windParticles.map((particle) => (
        <div
          key={particle.id}
          className="wind-particle"
          style={{
            top: `${particle.top}%`,
            animationDuration: `${particle.animationDuration}s`,
            animationDelay: `${particle.animationDelay}s`,
            opacity: particle.opacity
          }}
        >
          ~
        </div>
      ))}
    </div>
  );
};

// ==================== EFFET SOLEIL ====================
const SunEffect = () => {
  // Rayons de soleil
  const sunRays = Array.from({ length: 8 }, (_, i) => ({
    id: i,
    rotation: i * 45
  }));

  // Particules brillantes
  const sparkles = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: 20 + Math.random() * 60,
    top: 20 + Math.random() * 60,
    animationDelay: Math.random() * 3,
    size: 2 + Math.random() * 4
  }));

  return (
    <div className="weather-effect sun-effect">
      <div className="sun">
        <div className="sun-core"></div>
        {sunRays.map((ray) => (
          <div
            key={ray.id}
            className="sun-ray"
            style={{
              transform: `rotate(${ray.rotation}deg)`
            }}
          />
        ))}
      </div>
      {sparkles.map((sparkle) => (
        <div
          key={sparkle.id}
          className="sparkle"
          style={{
            left:  `${sparkle.left}%`,
            top: `${sparkle.top}%`,
            animationDelay: `${sparkle.animationDelay}s`,
            width: `${sparkle.size}px`,
            height: `${sparkle.size}px`
          }}
        />
      ))}
    </div>
  );
};

// ==================== EFFET AUTOMNE ====================
const AutumnEffect = ({ intensity }) => {
  const counts = { light: 20, medium: 35, heavy: 50 };
  const count = counts[intensity] || counts.medium;

  const leaves = ['🍂', '🍁', '🍃'];
  
  const fallingLeaves = Array.from({ length: count }, (_, i) => ({
    id: i,
    leaf: leaves[Math.floor(Math.random() * leaves.length)],
    left: Math.random() * 100,
    animationDuration:  5 + Math.random() * 8,
    animationDelay:  Math.random() * 5,
    fontSize: 15 + Math.random() * 25,
    opacity: 0.6 + Math.random() * 0.4
  }));

  return (
    <div className="weather-effect autumn-effect">
      {fallingLeaves.map((leaf) => (
        <div
          key={leaf.id}
          className="falling-leaf"
          style={{
            left: `${leaf.left}%`,
            animationDuration: `${leaf.animationDuration}s`,
            animationDelay: `${leaf.animationDelay}s`,
            fontSize: `${leaf.fontSize}px`,
            opacity: leaf.opacity
          }}
        >
          {leaf.leaf}
        </div>
      ))}
    </div>
  );
};

// ==================== EFFET VALENTIN ====================
const ValentinEffect = ({ intensity }) => {
  const counts = { light: 15, medium: 25, heavy: 40 };
  const count = counts[intensity] || counts.medium;

  const hearts = ['💕', '💖', '💗', '💓', '💝', '❤️', '💘'];
  
  const floatingHearts = Array.from({ length: count }, (_, i) => ({
    id: i,
    heart: hearts[Math.floor(Math.random() * hearts.length)],
    left: Math.random() * 100,
    animationDuration: 4 + Math.random() * 6,
    animationDelay: Math.random() * 4,
    fontSize: 15 + Math.random() * 20,
    opacity: 0.5 + Math.random() * 0.5
  }));

  return (
    <div className="weather-effect valentin-effect">
      {floatingHearts.map((heart) => (
        <div
          key={heart.id}
          className="floating-heart"
          style={{
            left:  `${heart.left}%`,
            animationDuration: `${heart.animationDuration}s`,
            animationDelay: `${heart.animationDelay}s`,
            fontSize: `${heart.fontSize}px`,
            opacity: heart.opacity
          }}
        >
          {heart.heart}
        </div>
      ))}
    </div>
  );
};

// ==================== EFFET PRINTEMPS ====================
const SpringEffect = ({ intensity }) => {
  const counts = { light: 20, medium: 30, heavy:  45 };
  const count = counts[intensity] || counts.medium;

  const flowers = ['🌸', '🌺', '🌼', '🌻', '🌷', '🏵️', '💐'];
  
  const floatingFlowers = Array.from({ length: count }, (_, i) => ({
    id: i,
    flower: flowers[Math. floor(Math.random() * flowers.length)],
    left: Math.random() * 100,
    animationDuration: 6 + Math.random() * 8,
    animationDelay: Math.random() * 5,
    fontSize: 18 + Math.random() * 22,
    opacity: 0.6 + Math.random() * 0.4
  }));

  // Papillons
  const butterflies = Array.from({ length: 5 }, (_, i) => ({
    id: i,
    animationDuration: 8 + Math.random() * 6,
    animationDelay:  Math.random() * 4
  }));

  return (
    <div className="weather-effect spring-effect">
      {floatingFlowers.map((flower) => (
        <div
          key={flower.id}
          className="floating-flower"
          style={{
            left: `${flower.left}%`,
            animationDuration: `${flower.animationDuration}s`,
            animationDelay: `${flower.animationDelay}s`,
            fontSize: `${flower.fontSize}px`,
            opacity: flower.opacity
          }}
        >
          {flower. flower}
        </div>
      ))}
      {butterflies.map((butterfly) => (
        <div
          key={`butterfly-${butterfly.id}`}
          className="butterfly"
          style={{
            animationDuration: `${butterfly.animationDuration}s`,
            animationDelay: `${butterfly.animationDelay}s`
          }}
        >
          🦋
        </div>
      ))}
    </div>
  );
};

export default WeatherEffect;